<template>
  <div class="personal">
    <div class="content">
      <aside class="aside">
        <div class="user-info">
          <img v-show="userInfo.headpic_url" class="user-image" :src="userInfo.headpic_url" alt="">
          <img v-show="!userInfo.headpic_url" class="user-image" src="@/assets/images/user.png" alt="">
          <div class="user-name">{{userInfo.nick_name}}</div>
          <div class="user-phone" v-if="userInfo.nick_name != userInfo.phone_num">{{userInfo.phone_num}}</div>
        </div>
        <router-link class="item" v-for="(item,index) in navList" :key="index" :to="item.value">
          {{item.name}}
        </router-link>
      </aside>
      <div class="personal-content">
        <div class="inner">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'personal',
  props: {
    msg: String
  },
  computed: {
    userInfo () {
      return this.$store.state.global.userInfo
    }
  },
  data() {
    return {
      navList: [
        {name: '会员中心', value: '/personal/vip'}, 
        {name: '消费记录', value: '/personal/list'},
      ],
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.personal {
  background-color: #F3F3F3;
  overflow: hidden;
}
.content {
  margin: 0 auto;
  position: relative;
  display: flex;
}
.aside {
  font-size: 18px;
  color: #FFFFFF;
  width: 200px;
  background: #fff;
  text-align: center;
  padding-top: 80px;
  box-sizing: border-box;
  overflow: hidden;
  .user-info {
    padding: 100px 0 20px 0;
    font-size: 14px;
    color: #555555;
    margin-bottom: 50px;
    border-bottom: 1px solid #EEEEEE;
    display: flex;
    flex-direction: column;
    align-items: center;
    .user-image {
      width: 60px;
      height: 60px;
      border-radius: 30px;
    }
    .user-name {
      margin: 10px 0;
    }
  }
  a {
    text-decoration: none;
    color: #555555;
    display: block;
  }
  .item {
    height: 80px;
    line-height: 80px;
    font-size: 18px;
    &.active {
      color: #4E6EFF;
    }
  }
}
.personal-content {
  width: 100%;
  padding: 100px 20px 20px 20px;
  box-sizing: border-box;
  min-height: 100vh;
  .inner {
    height: 100%;
    border-radius: 4px;
    box-sizing: border-box;
  }
}
</style>
